export const roles = {
        methods: {

            CHECK_ROLE_RESOURCE: function (whichNumber, whichModule) {
                if (this.CHECK_ROLE_MODULE(whichModule) === true) {
                    return true;
                }


                let ls = JSON.parse(localStorage.getItem("ur_risorsa"));
                if (ls.indexOf(parseInt(whichNumber)) > -1) {
                    return true;
                }
                return false;
            },

            CHECK_ROLE_MODULE: function (whichNumber) {
                let ls = JSON.parse(localStorage.getItem('ur_modulo'));
                if (ls.indexOf(parseInt(whichNumber)) > -1) {
                    return true;
                }
                return false;
            },

            CHECK_ROLE_CARD: function (whichNumber) {
                let ls = JSON.parse(localStorage.getItem('ur_part'));
                if (ls.indexOf(parseInt(whichNumber)) > -1) {
                    return true;
                }
                return false;
            },

            CHECK_LANGUAGE: function (payload) {
                let ls = localStorage.getItem('language');
                if (ls === payload) {
                    return true;
                }
                return false;


            },

            CHECK_ROLE_SIDEBAR: function (whichNumber) {
                let ls = JSON.parse(localStorage.getItem('ur_sidebar'));
                if (ls.indexOf(parseInt(whichNumber)) > -1) {
                    return true;
                }
                return false;
            },

            CHECK_TYPE: function (whichNumber) {
                let ls = localStorage.getItem('ur_type');
                if (parseInt(ls) === parseInt(whichNumber)) {
                    return true;
                }
                return false;
            }
        }
    }
;